import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogData, ConfirmDialogDismissAction } from '../components/confirm-dialog/ConfirmDialogData';

@Injectable()
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) { }
  dialogRef!: MatDialogRef<ConfirmDialogComponent>;

  private static readonly dismissResults: Record<ConfirmDialogDismissAction, boolean | undefined> = {
    cancel: false,
    confirm: true,
    secondOption: undefined,
  };

  public open(options: ConfirmDialogData) {
    // Material resolves a dismissal with undefined, which is also the second option's result, so a
    // backdrop click would be read as choosing it. Take dismissal over and resolve it as whichever
    // button the caller nominated, cancel unless they say otherwise.
    var dismissResult = ConfirmDialogService.dismissResults[options.dismissAction ?? 'cancel'];

    var dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message,
        cancelText: options.cancelText,
        confirmText: options.confirmText,
        actionIcon: options.actionIcon,
        actionColour: options.actionColour,
        secondOptionText: options.secondOptionText,
        secondOptionActionIcon: options.secondOptionActionIcon
      }
    });

    dialogRef.backdropClick().subscribe(() => dialogRef.close(dismissResult));
    dialogRef.keydownEvents()
      .pipe(filter(e => e.key === 'Escape'))
      .subscribe(() => dialogRef.close(dismissResult));

    this.dialogRef = dialogRef;
  }
  public confirmed(): Observable<any> {

    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
      return res;
    }
    ));
  }
}
